export enum NotificateType{
    CERTIFICATE="CERTIFICATE",
    CERTIFICATE_REQUEST="CERTIFICATE REQUEST",
    LOSSPAYEE="LOSSPAYEE",
    LOSS_PAYEE="LOSS PAYEE",
    STORAGE="STORAGE",
    ACCOUNTING = "ACCOUNTING",
    POLICY_RENEWAL="POLICY RENEWAL",
    FINSCAN = "FINSCAN",
    DELEGATIONS ="DELEGATIONS"

}